import React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

import Home from './template/home';
import HaimaAI from './template/ai';
import ChatPage from './template/chat'
import SmartMonitor from './template/smartMonitor';
import StarBackground from "./template/bg"

export default function App () {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-900 to-black text-sky-200 antialiased">
        {/* 背景光效 */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <StarBackground />
        </div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aichat" element={<HaimaAI />} />
          <Route path="/chatpage" element={<ChatPage />} />
          <Route path="/smartMonitor" element={<SmartMonitor />} />
        </Routes>
        {/* Footer */}
        <footer className="relative z-10 max-w-6xl mx-auto px-6 py-12">
          <div className="flex flex-col md:flex-row md:justify-between items-center gap-4">
            <div className='flex-1 text-center'>© {new Date().getFullYear()} 海马软件 • 保留所有权利</div>
          </div>
        </footer>
      </div>
    </Router>
  )
}
